import { CALL_API } from 'middleware/api';
import { POST_FUNNEL_EVENTS_FAILURE, POST_FUNNEL_EVENTS_REQUEST, POST_FUNNEL_EVENTS_SUCCESS, } from './types';
export const postFunnelEvents = (events) => ({
    [CALL_API]: {
        endpoint: '/events',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ events: events.map((type) => ({ type })) }),
        types: [
            POST_FUNNEL_EVENTS_REQUEST,
            POST_FUNNEL_EVENTS_SUCCESS,
            POST_FUNNEL_EVENTS_FAILURE,
        ],
        muteAlert: true,
        extra: { events },
    },
});
